import { leadsServiceApi } from '../../../../infra/purchasingApi.service';
import { PURCHASING_API } from '../../../../common/constants/api';

export const getBikesForPartEx = async (params) => {
    try {
        const res = await leadsServiceApi({
            method: 'get',
            url: `${PURCHASING_API.BIKE_INVENTORIES}?brandId=${params.brandId}&isArchived=false&limit=500`,
        });

        return {
            result: true,
            options: res.data,
        };
    } catch (e) {
        return {
            msg: e.message,
            error: e,
        };
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_create/requests/get_bikes_for_part_ex_request.js